import React, {useState, useEffect} from "react";

import "./login.css";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import EmailIcon from '@mui/icons-material/Email';
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Arrow from '../../assets/arrow.png';
import Service from '../../assets/service.png';
import Storefront from '../../assets/storefront.png';
import HeadQuarter from '../../assets/office.png';
import SDLogo from '../../assets/sd-logo-white.svg';
import Person from '../../assets/person.svg';
import Lock from '../../assets/lock.svg';
import { connect } from "react-redux";
import {loginRequest, loginReset} from '../../store/action/loginAction';
import {preLoginRequest, preLoginReset} from '../../store/action/preLoginAction';

const OTP_TIMER_SECONDS = 120;

const Login = ({loginSubmit, preLoginSubmit, resetLogin, resetPreLogin, isLogged, preLoginData, preLoginError, loginError, ...props}) => {
  const [inputUserName,setInputUserName]=useState("");
  const [inputEmail, setInputEmail] =useState("");
  const [inputPassword, setInputPassword] =useState("");
  const [type,setType]=React.useState("password");
  const [icon,setIcon]=React.useState(<VisibilityOffIcon/>);
  const [showOtpInput, setShowOtpInput] =useState(false);
  const [inputOtp, setInputOtp] =useState("");
  const [resendTimer, setResendTimer] =useState(0);

  const navigate= useNavigate();

  useEffect(()=>{
    resetLogin();
    resetPreLogin();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(()=>{
    if(isLogged){
      if(isLogged.status === false){
        Swal.fire({
          icon: 'error',
          text: 'Please Enter Correct Username and Password',
          confirmButtonColor: '#008d37',
          timer: 15000
        }).then(()=>resetLogin())
      }else{
        navigate('/dashboards');
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isLogged])

  useEffect(()=>{
    if(preLoginData){
      if(preLoginData.status === false){
        setShowOtpInput(false);
        setInputOtp("");
        setResendTimer(0);
        Swal.fire({
          icon: 'error',
          text: preLoginData.message || 'Please Enter Correct Username, Email and Password',
          confirmButtonColor: '#008d37',
          timer: 15000
        }).then(()=>resetPreLogin())
      }else{
        setShowOtpInput(true);
        setResendTimer(OTP_TIMER_SECONDS);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[preLoginData])

  useEffect(()=>{
    if(preLoginError){
      setShowOtpInput(false);
      setInputOtp("");
      setResendTimer(0);
      Swal.fire({
        icon: 'error',
        text: preLoginError,
        confirmButtonColor: '#008d37',
        timer: 15000
      }).then(()=>resetPreLogin())
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[preLoginError])

  useEffect(()=>{
    if(loginError){
      Swal.fire({
        icon: 'error',
        text: loginError,
        confirmButtonColor: '#008d37',
        timer: 15000
      }).then(()=>resetLogin())
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[loginError])

  useEffect(()=>{
    if(resendTimer <= 0){
      return;
    }
    const intervalId = setInterval(()=>{
      setResendTimer((prevTimer)=>prevTimer - 1);
    },1000);
    return ()=>clearInterval(intervalId);
  },[resendTimer])

  const handleToggle=()=>{
        if(type === 'password'){
          setIcon(<VisibilityIcon/>);
          setType("text");
        }else{
          setIcon(<VisibilityOffIcon/>);
          setType("password");
        }
    }

  const allowedEmailDomains=["@mahindraswaraj.com","@mahindra.com","@techmahindra.com"];

  const isAllowedEmailDomain=(email)=>
    allowedEmailDomains.some((domain)=>email.toLowerCase().endsWith(domain));

  const handleSubmit=()=>{
    if(inputUserName !== "" && inputEmail !== "" && inputPassword !== ""){
      if(!isAllowedEmailDomain(inputEmail)){
        setShowOtpInput(false);
        setInputOtp("");
        setResendTimer(0);
        Swal.fire({
          icon: 'error',
          text: 'Please Enter a Valid Email',
          confirmButtonColor: '#008d37',
          timer: 15000
        })
        return;
      }
      let requestUser={
        username:inputUserName,
        email: inputEmail,
        password: inputPassword
      };
      preLoginSubmit({requestUser});
    }else{
      setShowOtpInput(false);
      setInputOtp("");
      setResendTimer(0);
      Swal.fire({
        icon: 'error',
        text: 'Please Enter Username, Email and Password',
        confirmButtonColor: '#008d37',
        timer: 15000
      })
    }
  }

  const handleOtpChange=(e)=>{
    const value=e.target.value.replace(/[^0-9]/g,"").slice(0,4);
    setInputOtp(value);
  }

  const handleResendOtp=()=>{
    setInputOtp("");
    handleSubmit();
  }

  const handleOtpSubmit=()=>{
    if(inputOtp.length !== 4){
      Swal.fire({
        icon: 'error',
        text: 'Please Enter a Valid 4-Digit OTP',
        confirmButtonColor: '#008d37',
        timer: 15000
      })
      return;
    }
    let requestUser={
      username:inputUserName,
      email: inputEmail,
      otp: inputOtp
    };
    loginSubmit({requestUser});
  }

  const formatTimer=(seconds)=>{
    const minutes=Math.floor(seconds/60);
    const remainingSeconds=seconds%60;
    return `${minutes}:${remainingSeconds.toString().padStart(2,"0")}`;
  }

  return (
    <div className="rootLogin">
      <div className="rootLeft-wrapper">
        <div className="rootLeft">
        <div className="logo">
            <img src={SDLogo} alt="swaraj logo"  width="160" height="50"/>
          </div>
          <div className="secure">
            <div>Secure Access For :</div>
            <div className="secure-items-wrapper">
              <div>
                <img src={HeadQuarter} alt="office"/>
                <p>HQ</p>
              </div>
              <div>
                <img src={Storefront} alt="dealer"/>
                <p>Dealer</p>
              </div>
              <div>
                <img src={Service} alt="service"/>
                <p>Support</p>
              </div>
            </div>
          </div>
          <div className="intro">
            <h2>Welcome to Smart Protect</h2>
            <p>Enter your username and password to continue</p>
          </div>
          <h3 className="logIn">Log In</h3>
          <div className="inputWrapper">
              <img src={Person} alt="person"/>
              <input 
                type="text"
                className="inputBox"
                value={inputUserName}
                placeholder="UserName"
                onChange={(e) => setInputUserName(e.target.value)}/>
          </div>
          <div className="inputWrapper">
              <EmailIcon sx={{ width: 18, height: 18, color: '#666666' }}/>
              <input
                type="email"
                className="inputBox"
                value={inputEmail}
                placeholder="Email"
                onChange={(e) => setInputEmail(e.target.value)}/>
          </div>
          <div className="inputWrapper">
              <img src={Lock} alt="lock"/>
              <input
                type={type}
                className="inputBox"
                value={inputPassword}
                placeholder="Password"
                onChange={(e) => setInputPassword(e.target.value)}/>
              <span onClick={handleToggle} className="eyeIcon">{icon}</span>
          </div>
          {showOtpInput && (
            <div className="inputWrapper">
                <img src={Lock} alt="lock"/>
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={4}
                  className="inputBox"
                  value={inputOtp}
                  placeholder="Enter OTP"
                  onChange={handleOtpChange}/>
            </div>
          )}
          {showOtpInput && (
            <div className="resendOtp">
              {resendTimer > 0 ? (
                <p>Resend OTP in {formatTimer(resendTimer)}</p>
              ) : (
                <p onClick={handleResendOtp} className="resendOtpLink">Resend OTP</p>
              )}
            </div>
          )}
          {!showOtpInput && (
            <div className="submitButton" onClick={handleSubmit}>
              <p>Send OTP</p>
              <span><img src={Arrow} alt="arrow"/></span>
            </div>
          )}
          {showOtpInput && (
            <div className="submitButton" onClick={handleOtpSubmit}>
              <p>Submit OTP</p>
              <span><img src={Arrow} alt="arrow"/></span>
            </div>
          )}
        </div>
      </div>
      <div className="rootRight"></div>
    </div>
  );
};

const mapStateToProps=(state) => ({
  isLogged: state.loginReducer.userData,
  preLoginData: state.preLoginReducer.otpData,
  preLoginError: state.preLoginReducer.error,
  loginError: state.loginReducer.error,
})

const mapDispatchToProps = (dispatch) => ({
  loginSubmit: ({ requestUser }) =>
    dispatch(loginRequest({ requestUser })),
  preLoginSubmit: ({ requestUser }) =>
    dispatch(preLoginRequest({ requestUser })),
  resetLogin: () => dispatch(loginReset()),
  resetPreLogin: () => dispatch(preLoginReset()),
});


export default connect(mapStateToProps,mapDispatchToProps)(Login);
